export default "__VITE_ASSET__b3fa2a95__"